import * as z$1 from "zod/v4";
//#region src/schemas/daemon/runtime-transport-stop-cause.ts
const runtimeTransportStopCauseSchema = z$1.enum([
	"user_stop",
	"controlled_service_update",
	"service_crash",
	"network_disconnect",
	"unknown"
]);
//#endregion
export { runtimeTransportStopCauseSchema };

//# sourceMappingURL=runtime-transport-stop-cause.js.map